// Production uses the current origin (www and non-www both work, no CORS).
// Local CRA still talks to the API on port 1452.
function resolveBackendUrl() {
  if (typeof window === "undefined") return "";
  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "http://localhost:1452";
  }
  return "";
}

export const BACKEND_URL = resolveBackendUrl();
